import { createApp } from 'vue'
import App from './App.vue'
import "bootstrap/dist/css/bootstrap.min.css";
import "bootstrap";
import "@/assets/styles.scss";
import 'bootstrap-icons/font/bootstrap-icons.css';


createApp(App).mount('#app')
